import { render, staticRenderFns } from "./ProductPage6.vue?vue&type=template&id=e6600d48"
import script from "./ProductPage6.vue?vue&type=script&lang=js"
export * from "./ProductPage6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports